module.exports = __webpack_public_path__ + "static/media/urbangoo06.3552b7cc.webp";